import pick from "lodash/pick";
import get from "lodash/get";
import find from "lodash/find";
import firebase, { auth, db } from "@/firebase";
import result from "@/utils/result";
import ROLES from "@/assets/tables/roles.json";

export default {
  namespaced: true,
  state: {
    auth: null,
    claims: null,
    idToken: null
  },
  mutations: {
    updateAuth(state, payload) {
      if (!payload) {
        state.auth = null;
        state.claims = null;
        state.idToken = null;
      } else {
        const { auth, claims, token } = payload;
        state.auth = auth;
        state.claims = claims;
        state.idToken = token;
      }
    }
  },
  actions: {
    onAuth({ commit }) {
      auth.onIdTokenChanged(async auth => {
        if (auth) {
          const { token, claims } = await auth.getIdTokenResult();
          commit("updateAuth", { auth: auth.toJSON(), token, claims });
        } else {
          commit("updateAuth", null);
        }
      });
    },
    async signIn({ commit }, token) {
      return await auth.signInWithCustomToken(token);
    },
    async signOut() {
      return await auth.signOut();
    },
    async getIdToken() {
      return await auth.currentUser.getIdToken();
    }
  },
  getters: {
    isSignIn: state => state.auth !== null,
    uid: state => get(state.auth, "uid"),
    profile: state => {
      if (!state.auth) return null;

      return {
        uid: get(state.auth, "uid"),
        displayName: get(state.auth, "displayName")
      };
    },
    role: state => get(state.claims, "role", null),
    manageRegion: state => get(state.claims, "manageRegion", null),
    isActived: state => get(state.claims, "actived", false),
    permissionLevel: state => {
      const role = ROLES[get(state.claims, "role")];
      return role ? role.level : 0;
    }
  }
};
